var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-main',{staticClass:"grey lighten-4 pa-8"},[_c('nuxt')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }